import { render, staticRenderFns } from "./richtext-tinymce.vue?vue&type=template&id=db93ae3e&scoped=true&"
import script from "./richtext-tinymce.vue?vue&type=script&lang=js&"
export * from "./richtext-tinymce.vue?vue&type=script&lang=js&"
import style0 from "./richtext-tinymce.vue?vue&type=style&index=0&id=db93ae3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db93ae3e",
  null
  
)

export default component.exports